// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {
  CloudFunctionsPathBuilder,
  CloudRunPathBuilder,
  Env,
  IConsumerEnvironment,
  buildTenantConfig,
  envToProjectId,
  getEnvDomain,
} from 'shared-lib'

const env: Env = 'dev'
const projectId = envToProjectId[env]

const cloudFunctionsBuilder = new CloudFunctionsPathBuilder(env)

const projectNumber = '937797181068'
const projectHash = '5xd4v25phq'
const cloudRunBuilder = new CloudRunPathBuilder(projectNumber)

export const environment: IConsumerEnvironment = {
  production: false,
  env,
  firebaseConfig: {
    apiKey: 'AIzaSyBai0RKReaIHrtYQ_tM7S0081hhL-EZQXg',
    appId: '1:937797181068:web:a3a30e745d4b606875a5a9',
    authDomain: `${projectId}.firebaseapp.com`,
    measurementId: 'G-K2YFSVHMCG',
    messagingSenderId: '937797181068',
    projectId,
    storageBucket: `${env}-content.instockdepot.com`,
  },
  services: {
    auth: cloudRunBuilder.build('auth'),
    cloudFunctions: cloudFunctionsBuilder.build(),
    commerce: cloudRunBuilder.build('commerce'),
    content: cloudRunBuilder.build('content'),
    customer: cloudRunBuilder.build('customer'),
    events: cloudRunBuilder.build('events'),
    files: cloudRunBuilder.build('files'),
    integration: cloudRunBuilder.build('integration'),
    messaging: cloudRunBuilder.build('messaging'),
    notifications: cloudRunBuilder.build('notifications'),
    product: cloudRunBuilder.build('product'),
    productItem: cloudRunBuilder.build('productItem'),
    registration: cloudRunBuilder.build('registration'),
    seller: cloudRunBuilder.build('seller'),
    user: cloudRunBuilder.build('user'),
  },
  _business_EmailActionRoute: 'http://localhost:4610/#/auth/actions',
  algoliaAppId: 'PN2ZAA0VB6',
  algoliaSearchKey: 'cbe7e6782fb2f61fd2bf2782670c448a',
  // We can turn authentication off in case we are using this application inside and SDK and do not want to have any authentication
  authentication: false, // Look to the auth guard for use of this value
  basePlatformHost: getEnvDomain(env, 'app.instockdepot.com'),
  cdnCname: getEnvDomain(env, 'content.instockdepot.com'),
  emailVerificationEmailTemplateId: '2LKYubs8e8JqMm17XrZW',
  passwordRecoveryEmailTemplateId: 'GQKsG5Wnv9sWJ9uY3aDf',
  stripePublishableKey: 'pk_test_51L1Y8bDfdeY2QXyZWiLbL4qsie9qfLOxC4jPOH1vhG4wkJ7o87UscmIjXa08nbG4pnX5kkRjhjSd1I18kXW9qEMt005MVFl4i9',
  tenant: {
    appConfigBaseURL: `https://${getEnvDomain(env, 'content.instockdepot.com')}/assets/bootstrap`,
    defaultTenant: 'construction2.dev.instockdepot.app',
  },
  tenantId: 'construction2-3gp29',
  themesEnabled: true,
  v2ReCaptcha: '6Leq3oMrAAAAAPAeuBKk2go5HVRmHeV9-7_YNYwc',
  version: 'a99190f',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
